import BottomSheet from "../BottomSheet/BottomSheet";
import styles from "./OptionsBottomSheet.module.scss";
import ChevronLeftIcon from "../../assets/icons/chevron-left-black-icon.svg?react";
import ChevronRightIcon from "../../assets/icons/chevron-right-black-icon.svg?react";

export type Option = {
  label: string;
  key?: string;
  subtitle?: string;
  onClick: () => void;
  disabled?: boolean;
  preventClose?: boolean;
  isBack?: boolean;
  hasChevronRight?: boolean;
};

interface OptionsBottomSheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  options: Option[];
  classNames?: {
    rowTitle?: string;
    label?: string;
    subtitle?: string;
  };
  value?: string;
  showRadioIcons?: boolean;
}

const OptionsBottomSheet = ({
  open,
  onClose,
  title,
  options,
  value,
  classNames,
  showRadioIcons,
}: OptionsBottomSheetProps) => {
  const {
    sheetContent,
    titleStyle,
    optionButton,
    optionTextDisabled,
    optionsStyle,
    rowTitle,
    optionText,
    optionTextSelected,
    radioCircle,
    radioCircleSelected,
    radioDot,
    chevronIcon,
    chevronRightIcon,
  } = styles;

  return (
    <BottomSheet open={open} onClose={onClose} maxHeight="85dvh">
      <div className={sheetContent}>
        {title && <h1 className={titleStyle}>{title}</h1>}
        <div className={optionsStyle}>
          {options.map((option, index) => {
            const isSelected = !!(value && option.key === value);
            return (
              <button
                key={index}
                className={optionButton}
                onClick={() => {
                  option.onClick();
                  if (!option.preventClose) onClose();
                }}
                disabled={option.disabled}
              >
                <div className={`${rowTitle} ${classNames?.rowTitle || ""}`}>
                  {showRadioIcons && (
                    option.isBack
                      ? <ChevronLeftIcon className={chevronIcon} />
                      : (
                        <div className={`${radioCircle} ${isSelected ? radioCircleSelected : ""}`}>
                          {isSelected && <div className={radioDot} />}
                        </div>
                      )
                  )}
                  <div
                    className={`${
                      option.disabled ? optionTextDisabled : ""
                    } ${optionText} ${classNames?.label || ""} ${isSelected ? optionTextSelected : ""}`}
                    translate="no"
                  >
                    {option.label}
                    {option.subtitle && (
                      <p className={`${classNames?.subtitle || ""}`}>
                        {option.subtitle}
                      </p>
                    )}
                  </div>
                  {option.hasChevronRight && (
                    <ChevronRightIcon className={chevronRightIcon} />
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </BottomSheet>
  );
};

export default OptionsBottomSheet;
